
import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './style.css';

const Tooltip = ({ children, content, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (isVisible && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      let top = 0;
      let left = 0;
      
      // Basic positioning logic
      // We'll refine this if needed, but for now simple top/bottom works
      const offset = 8; // Gap between element and tooltip

      switch (position) {
        case 'top':
          top = rect.top - offset;
          left = rect.left + rect.width / 2;
          break;
        case 'bottom':
          top = rect.bottom + offset;
          left = rect.left + rect.width / 2;
          break;
        case 'left':
          top = rect.top + rect.height / 2;
          left = rect.left - offset;
          break;
        case 'right':
          top = rect.top + rect.height / 2;
          left = rect.right + offset;
          break;
        default:
          top = rect.top - offset;
          left = rect.left + rect.width / 2;
      }

      setCoords({ top, left });
    }
  }, [isVisible, position]);

  const handleMouseEnter = () => setIsVisible(true);
  const handleMouseLeave = () => setIsVisible(false);

  // Calculate generic styles for positioning the tooltip content centered relative to the point
  const getTooltipStyle = () => {
    if (!isVisible) return {};
    
    const style = {
      top: `${coords.top}px`,
      left: `${coords.left}px`,
    };

    // Adjust transforms to center the tooltip on the calculated point
    switch (position) {
      case 'top':
        style.transform = 'translate(-50%, -100%)';
        break;
      case 'bottom':
        style.transform = 'translate(-50%, 0)';
        break;
      case 'left':
        style.transform = 'translate(-100%, -50%)';
        break;
      case 'right':
        style.transform = 'translate(0, -50%)';
        break;
      default:
        style.transform = 'translate(-50%, -100%)';
    }

    return style;
  };

  return (
    <>
      <div 
        className="tooltip-container" 
        ref={triggerRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>
      {isVisible && ReactDOM.createPortal(
        <div 
          className="tooltip-portal" 
          style={getTooltipStyle()}
          ref={tooltipRef}
        >
          {content}
          {/* Arrow could be added here if needed, but CSS shapes are easier if relative to tooltip box. 
              Since we use transform, adding an arrow requires careful positioning. 
              For now, simple box is fine as requested "larger overlay". */}
        </div>,
        document.body
      )}
    </>
  );
};

export default Tooltip;
